module.exports = __webpack_public_path__ + "static/media/Location_Book-Page45.94a522ba.png";